
import Swiper from "swiper";
import { find } from "../utils/dom";

const GaleriaImagem = () =>{

	const classSwiper = find(".swiper-galeria-mobile");
	if(!classSwiper) return;



	const swiperGaleria = new Swiper(classSwiper,{
		slidesPerView: classSwiper.dataset.perview ?? 1.2,
		spaceBetween: 20,
		centeredSlides: true,
		watchSlidesProgress: true,
    pagination: {
      el: ".container-galeria .swiper-pagination",
      clickable: true,
			dynamicBullets: true
    },
		breakpoints:{
			767:{
				pagination: {
					dynamicBullets: false
				}
			}
		},
	});

}

export default GaleriaImagem;